import { render, staticRenderFns } from "./TransactionPrintOverlay.vue?vue&type=template&id=ff295746&scoped=true&"
import script from "./TransactionPrintOverlay.vue?vue&type=script&lang=ts&"
export * from "./TransactionPrintOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionPrintOverlay.vue?vue&type=style&index=0&id=ff295746&lang=scss&scoped=true&"
import style1 from "./TransactionPrintOverlay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff295746",
  null
  
)

export default component.exports